// extracted by extract-css-chunks-webpack-plugin
module.exports = {"shippingPhonenumber":"ukbKQ"};